import script from "./teamSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./teamSlide.vue?vue&type=script&setup=true&lang=js"

import "./teamSlide.vue?vue&type=style&index=0&id=33908d83&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33908d83"]])

export default __exports__